import { type ImageProps, Image } from '@pets-ui/Image/Image'
import { ImageBase } from '@pets-ui/Image/ImageBase'
import { PlaceholderNoImage } from '@pets-ui/Placeholder/PlaceholderNoImage'
import * as stylex from '@stylexjs/stylex'

const _frameStyles = stylex.create({
  frame: {
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    left: 0,
    top: 0,
    width: '100%',
  },
})

const fallbackElement = <PlaceholderNoImage width="100%" aspectRatio="1 / 1" noBorder />

export interface ImageProductProps extends ImageProps {
  frameUrl?: string
}

export const ImageProduct = (props: ImageProductProps) => {
  const { frameUrl, ...imageProps } = props

  return (
    <div style={{ position: 'relative', height: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', border: '1px solid rgba(0, 0, 0, 0.08)' }}>
      <Image
        {...imageProps}
        fallback={fallbackElement}
        loadingFallback={fallbackElement}
      />
      {frameUrl && (
        <div {...stylex.props(_frameStyles.frame)}>
          <ImageBase
            src={frameUrl}
            width="100%"
            height="100%"
            alt=""
            style={{ objectFit: 'cover' }}
          />
        </div>
      )}
    </div>
  )
}
